import React, { useEffect } from "react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
// import sch from "../../images/sch.jpg";
import l2l from "../../images/l2l.jpg";
import pencils from "../../images/pencils.jpg";
import slatepencil from "../../images/slatepencil.jpg";
import bgmi from "../../images/S.png";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/autoplay";

const Header = () => {
  useEffect(() => {
    // console.log("Swiper component mounted");
  }, []);

  const isMobile = window.innerWidth < 768; 
  return (
    <div style={{objectFit:"cover", width: "100%", height: isMobile ? "75vh" : "98vh", padding:" 0px 10px"}}>
      <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y]}
        spaceBetween={30}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        scrollbar={{ draggable: true }}
        style={{ width: "100%", height: "92%" }}
        // onSwiper={(swiper) => console.log(swiper)}
        // onSlideChange={() => console.log("slide change")}
        autoplay={{ delay: 2000 }}
      >
        <SwiperSlide>
          <img
            src={bgmi}
            alt="Slide 1"
            style={{ width: "100%", height: "100%" }}
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={l2l}
            alt="Slide 2"
            style={{ width: "100%", height: "100%" }}
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={pencils}
            alt="Slide 3"
            style={{ width: "100%", height: "100%" }}
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={slatepencil}
            alt="Slide 4"
            style={{ width: "100%", height: "100%" }}
          />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Header;
